import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Dashboard from './pages/Dashboard';
import { DashboardProvider } from './context/DashboardContext';
import AuthContext from './context/AuthContext';
import Stock from './pages/Stock';
import Sales from './pages/Sales';
import Debts from './pages/Debts';
import Suppliers from './pages/Suppliers';
import Reports from './pages/Reports';
import Login from './pages/Login';
import Register from './pages/Register';
import LandingPage from './pages/LandingPage';
import Profile from './pages/Profile';
import Team from './pages/Team';
import Clients from './pages/Clients';
import Expenses from './pages/Expenses';
import SupplierDebts from './pages/SupplierDebts';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AcceptInvitation from './pages/AcceptInvitation';
import ClientDetail from './pages/ClientDetail';
import TeamMemberDetail from './pages/TeamMemberDetail';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Spinner from './components/Spinner';
import VerifyEmail from './pages/VerifyEmail';
import ResendVerification from './pages/ResendVerification';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import PublicShop from './pages/PublicShop'; // Nouvelle boutique publique
import AdminPanel from './components/AdminPanel';

const PrivateRoute = ({ children }) => {
  const { token, loading } = useContext(AuthContext);
  if (loading) {
    return <div className="flex items-center justify-center h-screen"><Spinner message="Vérification de la session..." /></div>;
  }
  return token ? children : <Navigate to="/login" />;
};

const AdminRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);
  
  if (loading) {
    return <div className="flex items-center justify-center h-screen"><Spinner message="Vérification des droits..." /></div>;
  }

  const isAdmin = user?.role === 'admin' || !!user?.isAdmin || user?.username === 'Ndiaye';
  return user && isAdmin ? children : <Navigate to="/dashboard" replace />;
};

const DashboardRoutes = () => (
  <Routes>
    <Route index element={<Dashboard />} />
    <Route path="stock" element={<Stock />} />
    <Route path="sales" element={<Sales />} />
    <Route path="debts" element={<Debts />} />
    <Route path="clients" element={<Clients />} />
    <Route path="suppliers" element={<Suppliers />} />
    <Route path="expenses" element={<Expenses />} />
    <Route path="supplier-debts" element={<SupplierDebts />} />
    <Route path="reports" element={<Reports />} />
    <Route path="profile" element={<Profile />} />
    <Route path="team" element={<Team />} />
    <Route path="team/:id" element={<TeamMemberDetail />} />
    <Route path="clients/:id" element={<ClientDetail />} />
    <Route path="admin" element={<AdminRoute><AdminPanel /></AdminRoute>} />
    {/* Redirige vers le dashboard si une route inconnue est demandée à l'intérieur du dashboard */}
    <Route path="*" element={<Navigate to="/dashboard" replace />} />
  </Routes>
);

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/accept-invitation" element={<AcceptInvitation />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/resend-verification" element={<ResendVerification />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/shop/:shopSlug" element={<PublicShop />} /> {/* Nouvelle route publique pour les boutiques */}
        <Route
          path="/dashboard/*"
          element={
            <PrivateRoute>
              <DashboardProvider>
                <Layout>
                  <DashboardRoutes />
                </Layout>
              </DashboardProvider>
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={false} />
    </>
  );
}

export default App;
